<template>
  <b-modal id="editTenantModal">
    <b-form @submit="onSubmit">
      <b-form-group id="input-group-1" :label="$t('EDIT_TENANT')" label-for="input-1">
        <b-form-input v-model="Tenant.Name" type="text" required :placeholder="$t('ENT_TEN_NAME')"></b-form-input>
      </b-form-group>
      <b-form-group>
        <b-form-input
          v-model="Tenant.TeacherSeats"
          type="number"
          required
          :placeholder="$t('TEACHER_SEATS')"
        ></b-form-input>
      </b-form-group>
      <b-form-group>
        <b-form-input
          v-model="Tenant.StudentSeats"
          type="number"
          required
          :placeholder="$t('STUDENT_SEATS')"
        ></b-form-input>
      </b-form-group>

      <b-form-group>
        <label for="licenseBegins">License Start Date</label>
        <b-form-input
            v-model="Tenant.LicenseBegins"
            type="date"
            required
            id="licenseBegins"
            :placeholder="$t('LICENSE_BEGINS')"
        ></b-form-input>
      </b-form-group>
      
      <b-form-group>
        <label for="licenseExpires">License Expiration Date</label>
        <b-form-input
          v-model="Tenant.LicenseExpires"
          type="date"
          id="licenseExpires"
          required
          :placeholder="$t('LICENSE_EXPIRES')"
        ></b-form-input>
      </b-form-group>

        <div class="d-flex align-items-center">
          <b-button type="submit" variant="primary">{{$t("UPDATE_TENANT")}}</b-button>
        </div>
    </b-form>
  </b-modal>
</template>
<script>
import { ajaxPut } from "../../ajax";
import {apiUrl} from "@/main";

export default {
  props: ["Tenant", "token"],
  data: function() {
    return {
      mdlShow: false
    };
  },
  methods: {
    onSubmit: function(event) {
      event.preventDefault();

      ajaxPut(
        apiUrl() +"/tenants/" +
          this.Tenant.ID,
        this.Tenant,
        this.editTenantSuccess,
        this.dataError,
        this.token
      );
    },
    dataError: function(status = 0) {
      if (status == 401) {
        this.$emit("logout");
        this.$router.push("/");
      }

      this.loading = false;
    },
    editTenantSuccess: function() {
        this.$bvToast.toast('Tenant updated!', { autoHideDelay: 5000, appendToast: true});
    }
  }
};
</script>